import { apiGet, apiPatch } from "../client";
import type { PurchaseTransactionListResponseApi } from "../models/purchaseTransaction";

export async function getAllPurchaseTransactions(params?: {
  outstandingOnly?: boolean;
  search?: string;
  limit?: number;
}): Promise<PurchaseTransactionListResponseApi> {
  const searchParams = new URLSearchParams();
  if (params?.outstandingOnly) searchParams.append("outstandingOnly", "true");
  if (params?.search) searchParams.append("search", params.search);
  if (params?.limit) searchParams.append("limit", String(params.limit));
  const query = searchParams.toString();
  return apiGet<PurchaseTransactionListResponseApi>(
    `transactions/purchases${query ? `?${query}` : ""}`,
  );
}

export async function updatePurchaseTransactionCategory(
  id: number,
  category: string,
): Promise<void> {
  return apiPatch<void>(`transactions/purchases/${id}/category`, { category });
}
